// Pure: derives the Goal Board summary strip from card states.
export const SUMMARY_SEPARATOR = " · ";

const IN_FLIGHT = new Set(["INTAKE", "PLAN", "EXECUTE", "TEST"]);

export function buildGoalsSummary(cards) {
  const building = cards.filter((c) => IN_FLIGHT.has(c.rawState)).length;
  const wrapping = cards.filter((c) => c.rawState === "CLOSE").length;
  const done = cards.filter((c) => c.rawState === "ARCHIVED").length;
  const blocked = cards.filter((c) => c.blockersLine.startsWith("Waiting on:")).length;
  const dusting = cards.filter((c) => c.needsDusting).length;

  const parts = [];
  if (building) parts.push({ key: "building", text: `${building} ${building === 1 ? "piece" : "pieces"} being built`, tone: "neutral" });
  if (wrapping) parts.push({ key: "wrapping", text: `${wrapping} wrapping up`, tone: "amber" });
  if (blocked) parts.push({ key: "blocked", text: `${blocked} waiting on you`, tone: "amber" });
  if (dusting) parts.push({ key: "dusting", text: `${dusting} needs dusting`, tone: "amber" });
  if (!parts.length) parts.push({ key: "quiet", text: done ? "everything on the board is done" : "the board is quiet — nothing in motion", tone: "green" });
  else if (done) parts.push({ key: "done", text: `${done} done`, tone: "neutral" });

  const tone = dusting || blocked ? "amber" : "neutral";
  return { parts, tone, text: parts.map((p) => p.text).join(SUMMARY_SEPARATOR) };
}